webpackJsonp([267260487189813],{

/***/ 339:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/2018-04-17-test-2/"},"frontmatter":{"title":"Test 2"}}}]}},"pathContext":{"tag":"test"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-test-e81d3e83f34d5b6a99f0.js